export const zh_CN = {
    title: '批准弹出窗口',
    content_sign: '点击继续完成签名或交易',
    content_login: '点击继续完成创建或连接钱包',
};
